import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'

const xl = defineStyle({
  // w: '600px',
})
const lg = defineStyle({
  // w: '600px',
})
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const sizes = {
  xl: definePartsStyle({ dialog: xl }),
  lg: definePartsStyle({ dialog: lg }),
}

export const modalTheme = defineMultiStyleConfig({
  baseStyle: {
    header: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '140%',
      borderBottom: '1px solid',
      borderBottomColor: 'presets.neutral.20',
    },
    body: {
      minHeight: '200px',
    },
    dialog: {
      borderRadius: '16px',
      bg: 'presets.neutral.0',
    },
    footer: {
      bg: 'presets.neutral.10',
      borderBottomRadius: '16px',
    },
  },
  variants: {},
  sizes,
})
